import axios from "axios";
import { getTurnstileToken, resetTurnstileToken } from "@/lib/turnstile";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function normalizeApiError(error) {
  const response = error?.response;
  const data = response?.data;
  const message =
    data?.message ||
    error?.message ||
    "We could not submit your application. Please try again.";
  const normalized = new Error(message);
  normalized.status = response?.status;
  normalized.errors = data?.errors || null;
  return normalized;
}

function protectedPayload(payload) {
  const turnstileToken = getTurnstileToken();

  if (!turnstileToken) {
    const error = new Error(
      "Complete the security check before submitting your application."
    );
    error.status = 403;
    throw error;
  }

  return {
    ...payload,
    turnstile_token: turnstileToken,
  };
}

async function submitApplication(path, payload) {
  try {
    const { data } = await axios.post(
      `${API}/applications/${path}`,
      protectedPayload(payload)
    );
    return data;
  } catch (error) {
    throw normalizeApiError(error);
  } finally {
    // Turnstile tokens are single-use. Reset after every submission attempt,
    // including duplicate, validation, and network failures.
    resetTurnstileToken();
  }
}

export function submitCreatorApplication(payload) {
  return submitApplication("creator", payload);
}

export function submitAmbassadorApplication(payload) {
  return submitApplication("ambassador", payload);
}

export { API };
